export default class Expenses {
  constructor(
    id,
    sum,
    type,
  ) {
    this.id = id;
    this.sum = sum;
    this.type = type;
  }

  static createFromData(data) {
    return new Expenses(
      data.id,
      data.sum,
      data.type
    )
  }

  static createNew() {
    return new Expenses(
      null,
      null,
      null
    );
  }
}
